// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"c4da8de9","463":"b285a3da","626":"97ea5750","874":"77395e5e","905":"ce730e56"}[chunkId] + ".chunk.js";
};